import React from 'react'
import { withTranslation } from 'react-i18next'

import './OfficesAccordionCard.css'

const OfficesAccordionCard = ({ t, accordionItem, onToggleCard }) => {
    const {
        id,
        name,
        address,
        contactPerson,
        description,
        documents,
        email,
        phone,
        active
    } = accordionItem

    const isActive = active

    return (
        <div className="offices-accordion-card">
            <button
                className={`accordion-card__button ${
                    isActive ? 'accordion-card__button--active' : ''
                }`}
                onClick={onToggleCard}
                data-id={id}
            >
                {name}
            </button>
            <div
                className={`accordion-card__content ${
                    isActive ? 'accordion-card__content--active' : ''
                }`}
            >
                <div className="accordion-card__content__container">
                    {description && (
                        <div
                            className="content__about"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    )}
                    <div className="content-details">
                        <div className="content-details__contact">
                            <h6 className="content-details__contact__title">
                                {t('accordion.contact')}
                            </h6>
                            <div className="content-details__contact__info">
                                <div className="contact-info">
                                    <span className="contact-info__name">{contactPerson}</span>
                                </div>
                                {address && (
                                    <div className="contact-info">
                                        <span className="contact-info__title">
                                            {t('accordion.address')}:
                                        </span>
                                        <span
                                            className="contact-info__list"
                                            dangerouslySetInnerHTML={{ __html: address }}
                                        />
                                    </div>
                                )}
                                {phone && (
                                    <div className="contact-info">
                                        <span className="contact-info__title">
                                            {t('accordion.phone')}:
                                        </span>
                                        <span
                                            className="contact-info__list"
                                            dangerouslySetInnerHTML={{ __html: phone }}
                                        />
                                    </div>
                                )}
                                {email && (
                                    <div className="contact-info">
                                        <span className="contact-info__title">Email:</span>
                                        <span
                                            className="contact-info__list"
                                            dangerouslySetInnerHTML={{ __html: email }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        {documents.length > 0 && (
                            <div className="content-details__questions">
                                <h6 className="content-details__questions__title">
                                    {t('accordion.questions')}
                                </h6>
                                {documents.map((doc, i) => (
                                    <div className="content-details__questions__doc" key={i}>
                                        <img src="/images/doc.png" alt="doc" />
                                        <span>
                                            <a
                                                href={doc.path}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {doc.title ? doc.title : doc.name}
                                            </a>
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withTranslation()(OfficesAccordionCard)
